import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ReferralManagement = () => {
  const [config, setConfig] = useState({ referrer_reward: 50, referee_reward: 50 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await axios.get(`${API}/admin/referral-config`);
        setConfig(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  const saveConfig = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/admin/referral-config`, config);
      toast.success("Referral configuration updated!");
    } catch (err) {
      toast.error("Failed to update referral config");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div data-testid="referral-management">
      <h1 className="text-2xl font-bold text-foreground mb-2">Referral Program</h1>
      <p className="text-muted-foreground mb-6">Configure rewards for referrers and new users</p>

      <div className="max-w-md space-y-6">
        <div className="p-4 bg-card rounded-xl border border-border">
          <Label>Referrer Reward (₹)</Label>
          <p className="text-sm text-muted-foreground mb-2">Amount existing user gets when their referral completes first ride</p>
          <Input type="number" value={config.referrer_reward} onChange={(e) => setConfig({...config, referrer_reward: parseFloat(e.target.value)})} />
        </div>

        <div className="p-4 bg-card rounded-xl border border-border">
          <Label>Referee Reward (₹)</Label>
          <p className="text-sm text-muted-foreground mb-2">Amount new user gets when they use a referral code</p>
          <Input type="number" value={config.referee_reward} onChange={(e) => setConfig({...config, referee_reward: parseFloat(e.target.value)})} />
        </div>

        <Button onClick={saveConfig} disabled={saving} className="w-full">
          {saving ? "Saving..." : "Save Referral Config"}
        </Button>
      </div>
    </div>
  );
};

export default ReferralManagement;
